module.exports = __webpack_public_path__ + "static/media/demo.56dba35f.png";


//////////////////
// WEBPACK FOOTER
// ./src/display/platform/CompanyInfo/Qualification/imgs/demo.png
// module id = 979
// module chunks = 0